import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Container,
  Box,
  AppBar,
  Toolbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  appBar: {
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
  },
  title: {
    color: '#333',
    flexGrow: 1
  },
  container: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    padding: theme.spacing(2),
    maxWidth: '600px'
  },
  card: {
    width: 'fit-content',
    margin: '0 auto',
    textAlign: 'center'
  },
  cardTitle: {
    marginBottom: theme.spacing(2)
  },
  button: {
    marginTop: theme.spacing(2)
  },
  footer: {
    textAlign: 'center',
    padding: theme.spacing(2),
    marginTop: 'auto'
  },
  beianLink: {
    color: '#666',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

function Home() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            一里未来小道具
          </Typography>
        </Toolbar>
      </AppBar>

      <Container className={classes.container}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h5" component="h2" className={classes.cardTitle}>
              Sherlock's Pocket Money
            </Typography>
            <Typography color="textSecondary">
              记录 Sherlock 的零花钱使用情况
            </Typography>
            <Box mt={2}>
              <Button 
                component={Link} 
                to="/pocket-details" 
                variant="contained" 
                color="primary"
                className={classes.button}
              >
                查看详情
              </Button>
            </Box>
          </CardContent>
        </Card>
        
        <footer className={classes.footer}>
          <Typography variant="body2" color="textSecondary">
            <a 
              href="https://beian.miit.gov.cn" 
              target="_blank" 
              rel="noopener noreferrer"
              className={classes.beianLink}
            >
              沪ICP备2025113386号
            </a>
          </Typography>
        </footer>
      </Container>
    </div>
  );
}

export default Home;
